export const LinkBannerMock = {
  model: {
    noOfColumns: '4',
    componentId: 'mmkquezrdozmhqqh',
    headerTag: 'h3',
    impressionTrack: 'false',
    linkBannerHeader: 'Canada',
    hideColumDividers: true,
    trackingProperties: {
      enableScrollingBehavior: false,
      trackingDescription: '',
      impressionTrack: false,
      description: '',
      trackingContentPosition: '',
      atCCeVar48: '',
      rightArrowDesc: '',
      cardLocation: '',
      leftArrowDesc: '',
      clickTrack: false,
      location: '',
      merchandisingCategory: 'nonCobrand',
      impressionCount: false,
      trackingTag: '',
      trackingOfferType: '',
    },
    isAuthor: false,
    path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/accordioncontaineren/card-1/linkbanner_copy',
    ':type': 'mi-aem-common-spa/components/content/linkbanner',
    headerFontSize: 's',
    columnDetails: [
      {
        columnHeaderTag: 'h4',
        columnFontSize: 'm',
        linkItems: [
          {
            linkLabel: 'Calgary',
            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
            openInNewTab: false,
          },
        ],
      },
      {
        columnHeaderTag: 'h4',
        columnFontSize: 'm',
        linkItems: [
          {
            linkLabel: 'Montreal',
            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
            openInNewTab: true,
          },
        ],
      },
      {
        columnHeaderTag: 'h4',
        columnFontSize: 'm',
        linkItems: [
          {
            linkLabel: 'Toronto',
            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
            openInNewTab: false,
          },
        ],
      },
      {
        columnHeaderTag: 'h4',
        columnFontSize: 'm',
        linkItems: [
          {
            linkLabel: 'Vancouver',
            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
            openInNewTab: false,
          },
        ],
      },
    ],
    merchandisingCategory: 'nonCobrand',
    impressionCount: 'false',
    wcmMode: 'disabled',
  },
};
